/* Others */
import { makeFetchActionCreators, makeFetchActionTypes } from "../../../utils";

export const ACTION_TYPES_BASE_NAME = "player/content";

const GET_PLAYER_NEXT_LIVE_CONTENT = `${ACTION_TYPES_BASE_NAME}/GET_NEXT_LIVE_CONTENT`;
const actionCreators = makeFetchActionCreators(ACTION_TYPES_BASE_NAME);

export const { fetch: fetchPlayerContent, success: playerContentSuccess } = actionCreators;
export const actionTypes = { ...makeFetchActionTypes(ACTION_TYPES_BASE_NAME), GET_PLAYER_NEXT_LIVE_CONTENT };

export const getPlayerNextLiveContent = () => ({
  type: GET_PLAYER_NEXT_LIVE_CONTENT
});
